import { Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { interval, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  loading$ = this.loader.loading$;
  messages = [
    "loader.data-preparing",
    "loader.server-connexion",
    "loader.data-check",
    "loader.elements-loading",
    "loader.dont-reload",
    "loader.near-ending",
    "loader.one-moment",
    "loader.take-a-coffee",
    "loader.finalizing",
    "loader.thank-you"
  ];

  currentMessage: string = this.messages[0];
  private index: number = 0;
  private destroy$ = new Subject<void>();

  constructor(private loader: LoaderService) {
    interval(3000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.index = (this.index + 1) % this.messages.length;
        this.currentMessage = this.messages[this.index];
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
